import {
  Box,
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import React from 'react';

export interface MembershipUpdateModalProps {
  modalTitle: string;
  modalSubtitle: string;
  modalContentTitle?: JSX.Element;
  modalContentItems?: { itemTitle: string; beforeChange: string | JSX.Element; afterChange: string | JSX.Element }[];
  isOpen: boolean;
  closeModal: () => void;
  continueButtonLabel?: string;
  onContinue: () => void;
  editButtonLabel?: string;
  onEdit?: () => void;
}

export const MembershipUpdateModal: (props: MembershipUpdateModalProps) => JSX.Element = ({
  modalTitle,
  modalSubtitle,
  isOpen,
  modalContentTitle,
  modalContentItems,
  closeModal,
  continueButtonLabel,
  onContinue,
  editButtonLabel,
  onEdit,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        closeModal();
      }}
      className="membership-update-modal"
    >
      <ModalTitle id={`membershipUpdateModalTitle`} variant="h5">
        {modalTitle}
        <ModalCloseIconButton
          aria-label="Close"
          onClick={() => {
            closeModal();
          }}
        />
      </ModalTitle>
      <ModalContent id="membershipUpdateModalContent">
        <Stack className="modal-content-container" spacing={2}>
          <Stack className="modal-content-text" data-di-mask="true">
            <Typography variant="b1Regular">{modalSubtitle}</Typography>
            {modalContentTitle && (
              <Box sx={{ backgroundColor: '#F6F6F8', borderRadius: '0.5rem', padding: '1rem', marginTop: '1rem' }}>
                <Typography variant="b1Regular">{modalContentTitle}</Typography>
                {modalContentItems && (
                  <Stack gap="0.5rem" sx={{ marginTop: '1rem' }}>
                    {modalContentItems.map((item, index) => (
                      <Stack key={index} direction="row" justifyContent="space-between" alignItems="center">
                        <Typography key={index} variant="b1Regular">
                          {item.itemTitle}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Typography variant="b1Regular" sx={{ textDecoration: 'line-through', color: '#6C7175' }}>
                            {item.beforeChange}
                          </Typography>
                          <Typography variant="b1Bold">→ {item.afterChange}</Typography>
                        </Stack>
                      </Stack>
                    ))}
                  </Stack>
                )}
              </Box>
            )}
          </Stack>
        </Stack>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'shared',
          md: 'shared',
          lg: 'shared',
          xl: 'shared',
        }}
      >
        {onEdit && (
          <ModalActionButton
            variant="outlined"
            id="editUpdate"
            label={editButtonLabel || 'Edit address'}
            onClick={() => {
              onEdit();
            }}
          />
        )}

        <ModalActionButton
          variant="contained"
          id="confirmUpdate"
          label={continueButtonLabel || 'Continue'}
          onClick={() => {
            onContinue();
          }}
        />
      </ModalActions>
    </Modal>
  );
};
